module.exports = __webpack_public_path__ + "static/vpn-c496e577081ceea380ff12390b73624f.jpg";